import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { SingleLineSmartLinkProps } from './types.tsx';

export const SingleLineSmartLinkEntryPoint: EntryPoint<
	EntryPointComponent<{}, {}, SingleLineSmartLinkProps, {}>,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction(() =>
		import(/* webpackChunkName: "async-issue-field-single-line-smart-link" */ './index').then(
			(module) => module.SingleLineSmartLink,
		),
	),
	getPreloadProps: () => ({}),
});
